export default __webpack_public_path__ + "static/media/03_mercedes.157cda5a.png";